module.exports = __webpack_public_path__ + "img/featuredartist15 (5).b68c85ea.jpg";